import React, { useEffect } from "react";
import { history } from "../util/router";
import Meta from "./../components/Meta";
import HeroSection from "./../components/HeroSection";
import FeaturesSection from "./../components/FeaturesSection";
import { useAuth } from "../util/auth";
import { Button } from "@material-ui/core";
import { FormatItalic } from "@material-ui/icons";

// Choose base URL dynamically
const origin = window.location.origin;
const isLocalhost = origin.includes("localhost");
const baseUrl = isLocalhost ? "https://dev-www.shownav.net" : origin;

const video = `${baseUrl}/shownav-video.mp4`;

function IndexPage(props) {
  const auth = useAuth();

  useEffect(() => {
    // Redirect if not signed in
    if (auth?.user?.uid) {
      history.replace("/dashboard");
    }
  }, [auth]);

  return (
    <>
      <Meta />

      {/* HEADER */}
      <div style={{ paddingLeft: '5%', paddingRight: '5%', textAlign: 'center' }}>
        <div style={{ paddingTop: 40}}>
          <img
            src="showNAVLogo.png"
            style={{ height: 50, alignSelf: 'center' }}
            alt="Logo"
          />
        </div>
        {/* <span style={{ fontSize: '1rem' }}>Behind the Scenes, Ahead of the Curve.</span> */}
      </div>

      <div style={{ paddingLeft: '5%', paddingRight: '5%', textAlign: 'center' }}>
        <h2>ENTERTAINMENT LOGISTICS <span style={{fontStyle: 'italic'}}>EVOLVED</span></h2>
        {/* <p style={{ fontSize: '1rem', marginBottom: 0 }}>Entertainment Logistics</p>
        <span style={{ color: '#ffd600ff', fontWeight: 'bold' }}>EVOLVED</span> */}
      </div>

      {/* GET STARTED BUTTON */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          paddingBottom: 40,
          marginTop: 20,
          borderBottom: '.1px solid rgba(42, 44, 55, 1)',
        }}
      >
        <Button
          style={{ fontWeight: 800, width: 220, align: 'center' }}
          variant="contained"
          size="large"
          href="/auth/signup"
          color="primary"
        >
          GET STARTED
        </Button>
      </div>

      {/* VIDEO SECTION */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'hidden',
          borderBottom: '.1px solid rgba(42, 44, 55, 1)',
        }}
      >
        <video
          src={video}
          autoPlay
          loop
          muted
          playsInline
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>

      {/* OUR MISSION SECTION */}
      <div
        style={{
          paddingLeft: '5%',
          paddingRight: '5%',
          paddingBottom: 45,
          paddingTop: 45,
          textAlign: 'center',
          borderBottom: '.1px solid rgba(42, 44, 55, 1)',
        }}
      >
        <h1 style={{ fontSize: '2.125rem' }}>OUR MISSION</h1>
        <span style={{ fontSize: '1rem' }}>
          showNAV sets the <span style={{ color: '#ffd600ff', fontWeight: 'bold' }}>new standard</span> for logistics management in the entertainment industry. Our cutting-edge platform enhances efficiency, streamlines communication, and optimizes organization across your production. By enabling productions to create detailed location directories, showNAV empowers crew members to navigate directly via mobile app — minimizing confusion, reducing user error, and preventing costly delays.
        </span>
      </div>

      {/* FEATURES */}
      <FeaturesSection
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="FEATURES"
      />

      {/* CONTACT / HERO SECTION */}
      <span
        style={{
          width: '100%',
          borderBottom: '.1px solid rgba(42, 44, 55, 1)',
        }}
      ></span>
      <HeroSection
        bgColor="transparent"
        size="medium"
        title="ADVERTISE WITH US!"
        buttonText="CONTACT"
        buttonColor="primary"
        buttonPath="/contact"
      />
    </>
  );
}

export default IndexPage;
